import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { AlertTriangleIcon } from "lucide-react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (type: "link" | "access") => void;
    type?: "link" | "access";
}

export function DeactivateWorkspaceDialog({
    isOpen,
    onClose,
    onConfirm,
    type = "link",
}: Props) {
    const handleConfirm = () => {
        onConfirm(type);
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[480px]">
                <DialogHeader className="space-y-4">
                    <div className="flex items-center gap-3">
                        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
                            <AlertTriangleIcon className="h-5 w-5 text-red-600" />
                        </div>
                        <DialogTitle className="text-xl font-semibold">
                            Proceed to Deactivate?
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-base text-gray-600">
                        {type === "link"
                            ? "Upon deactivation, the workspace remains but the activation link sent to the recipient will become invalid."
                            : "Upon deactivation, the workspace remains but the access will be revoked and the recipient will no longer be able to use it."}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex gap-3 sm:gap-3 mt-4">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={onClose}
                        className="flex-1"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        onClick={handleConfirm}
                        className="flex-1 bg-red-600 hover:bg-red-700 text-white"
                    >
                        {type === "link" ? "Deactivate Link" : "Deactivate Access"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}